import React, { useEffect, useState } from 'react';
export function Countdown() {
  // Start with 23 hours, 59 mins, 45 secs
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 45
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev; // Stop at 0
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 md:gap-3 text-2xl md:text-5xl font-heading font-bold text-white my-3 md:my-6" data-id="element-58">
      <div className="flex flex-col items-center" data-id="element-59">
        <div className="bg-navy-900 border border-navy-700 rounded-lg p-2 md:p-4 min-w-[56px] md:min-w-[90px] text-center shadow-inner" data-id="element-60">
          {format(timeLeft.hours)}
        </div>
        <span className="text-[10px] md:text-sm text-gray-400 mt-1 font-sans font-normal uppercase tracking-wider" data-id="element-61">
          Horas
        </span>
      </div>
      <span className="text-gold-500 pb-4 md:pb-6" data-id="element-62">:</span>
      <div className="flex flex-col items-center" data-id="element-63">
        <div className="bg-navy-900 border border-navy-700 rounded-lg p-2 md:p-4 min-w-[56px] md:min-w-[90px] text-center shadow-inner" data-id="element-64">
          {format(timeLeft.minutes)}
        </div>
        <span className="text-[10px] md:text-sm text-gray-400 mt-1 font-sans font-normal uppercase tracking-wider" data-id="element-65">
          Min
        </span>
      </div>
      <span className="text-gold-500 pb-4 md:pb-6" data-id="element-66">:</span>
      <div className="flex flex-col items-center" data-id="element-67">
        <div className="bg-navy-900 border border-navy-700 rounded-lg p-2 md:p-4 min-w-[56px] md:min-w-[90px] text-center shadow-inner" data-id="element-68">
          {format(timeLeft.seconds)}
        </div>
        <span className="text-[10px] md:text-sm text-gray-400 mt-1 font-sans font-normal uppercase tracking-wider" data-id="element-69">
          Seg
        </span>
      </div>
    </div>;
}